export default class Navigation {

    constructor() {
        this.navigationToggle();
    }


    navigationToggle() {
        const navigation = document.querySelector('[data-navigation]');
        const burgerMenu = document.querySelector('[data-navigation-button]');
        let startX, startY;

        // Event listener for touchstart to capture the initial touch point
        document.addEventListener('touchstart', function(e) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        });

        // Event listener for touchend to determine the swipe direction
        document.addEventListener('touchend', function(e) {
            let endX = e.changedTouches[0].clientX;
            let endY = e.changedTouches[0].clientY;
            let diffX = endX - startX;
            let diffY = endY - startY;

            // Swipe right to close the navigation
            if (navigation.classList.contains('is-active') && diffX > 50 && Math.abs(diffY) < 30) {
                navigation.classList.remove('is-active');
                burgerMenu.classList.remove('is-active');
            }

            // Swipe from left edge to open the navigation
            if (startX < 30 && diffX < -50 && Math.abs(diffY) < 30 && !navigation.classList.contains('is-active')) {
                navigation.classList.add('is-active');
                burgerMenu.classList.add('is-active');
            }
        });

        // Toggle the navigation using the burger menu
        burgerMenu.addEventListener('click', function(e) {
            e.preventDefault();
            navigation.classList.toggle('is-active');
            burgerMenu.classList.toggle('is-active');
        });

        // Close the navigation if clicking outside of it
        document.addEventListener('click', function(e) {
            if (!navigation.contains(e.target) && !burgerMenu.contains(e.target)) {
                navigation.classList.remove('is-active');
                burgerMenu.classList.remove('is-active');
            }
        });
    }

}
